export const complianceStatus = {
  2: {
    label: 'Parcial Compliance',
    icon: 'bx bx-confused',
    background: '#c2d2e9',
    color: '#677c9b',
  },
  3: {
    label: 'Compliance',
    icon: 'bx bx-happy',
    background: '#bee1dd',
    color: '#4fa569',
  },
  4: {
    label: 'Não Compliance',
    icon: 'bx bx-sad',
    background: '#ffb2b2',
    color: '#cd5252',
  },
};
